module.exports = __webpack_public_path__ + "img/changeWidth-1.c1b5e90.png";